import { Text } from "@lightningjs/solid";

export default () => {
  return (
    <Text>Not Found</Text>
  );
};
